import React from 'react';

import useTranslate from '../../../common/hooks/useTranslate';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { CHANGE_SIDEBAR_EXPAND } from '../../../redux/types';
import { saveUserSettings } from '../../services/userService';

// @ts-ignore - In order to fix this we need to make custom config rule
import LogoSidebar from '../../../assets/images/logoSidebar.svg';
import Icon from '../../ui/icon/icon';

import Navigation from '../../ui/navigation/navigation';

import './sidebar.scss';

const Sidebar = () => {
  const dispatch = useDispatch();
  const expanded = useSelector((state: RootState) => state.sidebar.expanded);
  const { t } = useTranslate();

  const handleExpandSidebar = () => {
    let exp = expanded === '1' ? '0' : '1';
    const expandPayload = {name: 'p-sidebar-expand', value: exp};
    saveUserSettings(expandPayload);
    dispatch({type: CHANGE_SIDEBAR_EXPAND, payload: exp});
  }

  return (
    <div className={`sidebar-wrapper ${expanded === '1' ? 'expanded-sidebar' : ''}`}>
      <Icon
        name={`fas ${expanded === '1' ? 'fa-circle-chevron-left' : 'fa-circle-chevron-right'}`}
        className="nav-icon pointer expand-sidebar-btn"
        onClick={handleExpandSidebar}
      />
      <span className='sidebar-logo'>{t('LP')}</span>
      <Navigation />
      <div className='company-logo'>
        <img src={LogoSidebar} alt='CapInteract' />
      </div>
    </div>
  );
};

export default Sidebar;
